// src/flow/StaleMediaModal.jsx
import Button from "../components/common/Button";

export default function StaleMediaModal({ open, title, message, confirmLabel, keepLabel, onConfirm, onKeep }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black-900 bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-4 w-full max-w-[400px] shadow-xl">
        <h3 className="text-lg font-bold mb-4">{title}</h3>
        <p className="bg-link-100 text-black-800 text-lg px-2 mb-4">{message}</p>
        <div className="flex flex-col sm:flex-row justify-end gap-3 text-sm sm:text-lg font-bold">
          <Button variant="ghost" onClick={onKeep} className="w-full sm:w-auto">
            {keepLabel}
          </Button>
          <Button variant="dark" onClick={onConfirm} className="w-full sm:w-auto">
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}